<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.judgeRejectionRequest.title">
      <v-row>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.selectbox"
            :value.sync="judgeSocialId"
            :label="local.caseRelatedRequest.judgeRejectionRequest.judgeName"
            :items="judgesList"
            item-value="SocialID"
            item-text="Name"
            :validates="`required`"
            :disabled="isViewMode || isEditMode"
            @change="judgeSelectionChanged"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>
  </div>
</template>

<script>
import { mode } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'JudgeRejectionRequest',
  inject: ['$validator'],
  components: {},
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      judgesList: [],
      judgeSocialId: null,
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
  },
  watch: {},
  mounted() {
    if (this.formModel && this.formModel.judge && this.formModel.judge.length > 0) {
      this.judgeSocialId = this.formModel.judge[0].SocialID;
    }
  },
  created() {
    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };

    this.getCaseJudges(params)
      .then((res) => {
        this.judgesList = res.data.filter(x => x.SocialID !== null);
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    ...mapActions(['getCaseJudges']),
    judgeSelectionChanged() {
      const selectedJudge = this.judgesList.find(a => a.SocialID == this.judgeSocialId) || {};

      const mappedJudge = {
        Id: selectedJudge.UserId,
        Name: selectedJudge.Name,
        SocialID: selectedJudge.SocialID,
        Nationality: selectedJudge.Nationality,
        IdentityType: selectedJudge.IdentityType,
        LUTIdentityTypeId: selectedJudge.LUTIdentityTypeId,
        UserId: selectedJudge.UserId,

      };
      this.$set(this.formModel, 'judge', [mappedJudge]);
      this.$set(this.formModel, 'judgeSocialId', this.judgeSocialId);
    },
  },
};
</script>

<style lang="scss" scoped>
    .show-note {
        cursor: pointer;
        color: var(--app-primary-color);
        font-weight: bold;
    }

::v-deep .case-info-text {
  word-break: break-all;
}
</style>